import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ComponentsModule } from './components/components.module';

@NgModule({
    imports: [
        BrowserModule,
        ComponentsModule
    ],
    exports: [
        ComponentsModule
    ]
})
export class PdaCommonsModule { }
